//accordion menu for navigation component.

$(document).ready(function() {

    var windowWidth;
    var attached;
    checkWidth();

    function checkWidth() {
        windowWidth = $(window).width();
        if (windowWidth < 992) {
            if (attached !== false) {
                $('.context-navigation_expand')
                    .addClass('fa-plus')
                    .removeClass('fa-times')
            }
            attached = false;
        } else {
            if (attached !== true) {
                $('.context-navigation_expand')
                    .addClass('fa-times')
                    .removeClass('fa-plus')
            }
            attached = true;
        }
    }
	$(".cmp-navigation__parent--level-0").hide();
	
	$('li.cmp-navigation__item--active').each(function () {
		var currentLi = $(this);
		var currentExpansion = currentLi.find('.cmp-navigation__expand-collapse:first');
		if (currentExpansion.length > 0) {
			currentExpansion.children('.fa').switchClass('fa-plus', 'fa-minus', 1000, "easeInOutQuad")
			currentLi.addClass('open');
			currentLi.children('.cmp-navigation__parent--level').slideDown(750);
		}  
		
    });
	
// expand and collapse on click.
	$(".cmp-navigation__expand-collapse").on("click" , function(e) {
		e.preventDefault();
		
		var all_accordion_items = $(this).closest('.cmp-navigation__group').children('.accordion_item');
		var current_accordion_item = $(this).closest('.accordion_item');
		var prev_all_accordion_items = $(this).children('.fa');
		
		if(current_accordion_item.hasClass('open')) {
			all_accordion_items.removeClass('open');
			all_accordion_items.find('.accordion_item').removeClass('open');
			all_accordion_items.find('div.cmp-navigation__item-link').css( "background-color", "#fff" );
			all_accordion_items.find('.fa-minus').switchClass('fa-minus', 'fa-plus', 1000, "easeInOutQuad");
			all_accordion_items.find('.cmp-navigation__parent--level').slideUp(750);
		} else {
			all_accordion_items.removeClass('open');
			all_accordion_items.find('div.cmp-navigation__item-link').css( "background-color", "#fff" );
			all_accordion_items.find('.fa-minus').switchClass('fa-minus', 'fa-plus', 1000, "easeInOutQuad");
			all_accordion_items.children('.cmp-navigation__parent--level').slideUp(750);
			current_accordion_item.addClass('open');
			prev_all_accordion_items.switchClass('fa-plus', 'fa-minus', 1000, "easeInOutQuad");
			current_accordion_item.children('.cmp-navigation__parent--level').slideDown(750);
		}
	});

});
